import { render } from "./distpacheditForm.vue?vue&type=template&id=30497052&scoped=true"
import script from "./distpacheditForm.vue?vue&type=script&lang=js"
export * from "./distpacheditForm.vue?vue&type=script&lang=js"

import "./distpacheditForm.vue?vue&type=style&index=0&id=30497052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30497052"]])

export default __exports__